<template>
  <v-btn
    v-if="$attrs.icon && typeof $attrs.icon == 'string'"
    :color="primary ? 'primary' : undefined"
    :class="{ primary, borderless, block, white, gray, still }"
    :variant="variant || 'text'"
  />
  <v-btn v-else
    :color="primary ? 'primary' : undefined"
    :variant="primary ? 'flat' : 'outlined'"
    :class="{ primary, borderless, block, white, gray, still }"
  >
    <slot />
  </v-btn>
</template>

<script setup lang="ts">
import type { VBtn } from 'vuetify/components';

defineProps<{
  primary?: boolean;
  borderless?: boolean;
  block?: boolean;
  white?: boolean;
  gray?: boolean;
  still?: boolean;
  variant?: VBtn['variant'];
}>();
</script>

<style lang="scss">
.v-btn {
  text-transform: unset !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border-radius: var(--border-r-sm);
  letter-spacing: normal !important;

  &.flex {
    display: flex !important;
  }
  &:not(.primary) {
    border-color: #B8B8B8;
    color: #000;
  }
  &.block {
    width: 100%;
  }
  &.white {
    border-color: #fff;
    color: #fff;
    height: auto !important;
    padding: 10px 0;
  }
  &.gray {
    color: #fff;
    background: #D2D2D2;
    border-color: #D2D2D2;
  }

  &:hover {
    transform: scale(1.03);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }
  &.still:hover {
    transform: none;
    box-shadow: none;
  }
}
.v-btn__content {
  white-space: unset !important;
}
</style>